// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4044":"4bd998ad","7558":"d44cf8c7"}[chunkId] + ".chunk.css";
};